import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalCompanyUpdateProps {}

const ModalCompanyUpdate = ({}: ModalCompanyUpdateProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.updateCompany');
  const onClose = () => {
    closeSingleModal('updateCompany');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Atualizar companhia"
      height={'auto'}
      width={'30vw'}
    >
      <Form.Export.Company.Update />
    </Modal>
  );
};

export default ModalCompanyUpdate;
